export default __webpack_public_path__ + "static/media/093-up-arrow-2.c3da4d08.png";